import styled from 'styled-components';
import Checkbox from 'components/FormGroup/Checkbox';
import colors from 'themes/Main';

const { gray01, gray03, darkBlue, white } = colors;

const headerConfig = `
  width: calc((100% - 214px) / 7);
  min-width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 25px;
`;

export const RadioContainer = styled.div`
  display: flex !important;
  padding-left: 17px !important;
`;

export const CaixaDeSelecao = styled(Checkbox)`
  ${({ checked }) => `
    margin: 8px 0 16px;
    input[type='checkbox']:focus ~ div {
      box-shadow: 0 0 0 3px ${checked ? gray03 : 'transparent'}};
    }

    div,
    svg {
      width: 18px;
      height: 18px;
      stroke: ${white};
      stroke-witdth: 2px;
      background: ${checked ? gray01 : 'transparent'}
    }

    div {
      background: transparent;
      border-width: 2px;
      border-color: ${gray01};
      border-style: solid;
    }
  `}
`;

export const headerDiv = styled.div`
  ${headerConfig};

  &:last-of-type small {
    color: ${gray01};
    font-weight: 700;
    text-align: center;
    height: 38px;
  }
`;

export const headerDivSS = styled.div`
  ${({ blocks }) => `
  ${headerConfig};
    width: calc((100% - 214px) / ${blocks});
  `}
`;

export const headerSmall = styled.small`
  color: ${darkBlue};
  font-weight: 700;
  text-align: center;
  height: 38px;
`;

export const otherLangsContainer = styled.div`
  width: auto !important;
  max-width: 214px;
  text-align: left !important;
  small {
    color: ${gray03};
  }
`;

export const otherQuestionsContainer = styled.div`
  width: 100% !important;
  max-width: 100%;
`;

export const cbContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  min-width: 100%;
  width: fit-content;
  max-height: 340px;
`;

export const ButtonsContainer = styled.div`
  width: fill-available;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CertificatesContainer = styled.div`
  width: auto;
  height: auto;
  margin-bottom: 32px;
`;
